import React, { ReactElement } from 'react'
import styled from 'styled-components'

const PopupWrapper = styled.div`
  cursor: pointer;
  height: 100% !important;
  transition: transform 0.2s ease;
`

export const CaiBar = React.memo(({ children }: { children: ReactElement }) => {
  return (
    <div className="cai-bar-container">
      <PopupWrapper>{children}</PopupWrapper>
    </div>
  )
})
